










































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';

@Component
export default class ExtensionFile extends Vue {
  @Prop({ type: String, default: 'XLSX' }) extension!: string;
}
